import { coreApi } from 'src/api/config';

const fetchCustomConsentConfiguration = async ({ consentType, consentCode }) => {
  const response = await coreApi.query('custom_consent_configuration', {
    consent_code: consentCode,
    consent_type: consentType,
    state: 'active',
  });
  return response.data.data[0];
};

export default fetchCustomConsentConfiguration;
